import type { Lesson } from '@/types'

/**
 * Перенос разрешён для любого запланированного и фактически не начатого урока,
 * включая уроки с прошедшим плановым временем (урок мог пройти раньше плана).
 */
export function canRescheduleLesson(lesson: Lesson): boolean {
  if (lesson.status !== 'planned') {
    return false
  }

  if (lesson.actual_start_at) {
    return false
  }

  return Boolean(lesson.planned_start_at)
}
